module.exports = __webpack_public_path__ + "static/media/embs.236cb42f.pdf";